module.exports = __webpack_public_path__ + "img/55.5bce1ae6.jpg";